import React from "react";
import { Grid } from "@mui/material";
import LabeledSelect from "../../Widgets/LabeledSelect";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { MedicationsFormValues } from "./interface";

const MEDICATION_ADHERENCE_OPTIONS = [
  { value: "NOT_PRESCRIBED", label: "Not prescribed" },
  { value: "REGULARLY_MISSES_DOSES", label: "Regularly misses doses" },
  { value: "FREQUENT_CHALLENGING_BEHAVIOR", label: "Frequent challenging behavior around medication" },
  { value: "OCCASIONALLY_MISSES_DOSE", label: "Occasionally misses a dose" },
  { value: "ON_SCHEDULE_WITH_SUPPORT", label: "On schedule with caregiver support" },
  { value: "ON_SCHEDULE_100_INDEPENDENT", label: "On schedule, 100% independent" },
];

interface EditFieldsProps {
  formValues: MedicationsFormValues;
  handleChange: (
    field: keyof MedicationsFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledSelect
        label="Medication Adherence"
        value={formValues.medicationAdherence}
        onChange={handleChange("medicationAdherence")}
        options={MEDICATION_ADHERENCE_OPTIONS}
      />
      <LabeledTextArea
        multiline
        label="Coordination of Care Notes"
        name="coordinationOfCareNotes"
        value={formValues.coordinationOfCareNotes}
        onChange={handleChange("coordinationOfCareNotes")}
      />
    </Grid>
  );
};

export default EditFields;
